<template>
    <div class="wrapper" ref="parent">
        <slot name="activator" :onActivate="onActivate"></slot>
        <div class="popup"
             :class="{ centered, _desktop: desktopAndMore, _tablet: tabletAndLess, _phone: phoneAndLess }"
             v-if="getActivePopupId(id)"
             :style="centered ? {} : {
                top: compTop + 32 + 'px',
                left: left + 'px',
             }"
        >
            <div
                class="card"
                v-loading="loading"
                :class="{ _desktop: desktopAndMore, _tablet: tabletAndLess, _phone: phoneAndLess }"
                @click.stop
            >
                <div
                    v-if="tabletAndLess"
                    class="close"
                    @click="close"
                >
                    <font-awesome-icon
                        class="icon"
                        icon="times"
                    />
                </div>
                <div class="title">Возможные даты начала обучения</div>
                <div class="radio-group">
                    <RadioGroup
                        :items="dateList"
                        item-key="key"
                        item-value="value"
                        @change="radioGroupChangeHandler"
                    />
                </div>

                <div
                    class="calendar-btn" @click="applyDate"
                    :class="{ disable: isBtnDisable }"
                >Применить
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import moment from 'moment';

import RadioGroup from './RadioGroup';

const popupsControllerGetters = [
    'getActivePopupId',
];
const popupsControllerActions = [
    'openSinglePopup',
    'closePopup',
];

export default {
    name: 'ListDataPicker',
    components: {
        RadioGroup,
    },
    data: () => ({
        date: null,
        top: 0,
        left: 0,
        id: `f${(~~(Math.random() * 1e8)).toString(16)}`,
    }),
    props: {
        items: Array,
        centered: {
            type: Boolean,
            default: false,
        },
        loading: Boolean,
        isCustomActivatorEvent: {
            type: Boolean,
            default: false,
        },
        // идея popupController в том, что попапы должен вызывать app.vue методом setPopup, а все остальные элементы предзаписывают id вызываемого попапа. appVue подписан на click. если хотим активировать попап по любому другому событию, необходимо передать флаг isCustomActivatorEvent если событие отлично от клика.
    },
    methods: {
        ...mapActions('popupsController', popupsControllerActions),
        updatePosition() {
            this.top = this.$refs.parent.getBoundingClientRect().top;
            this.left = this.tabletAndLess && !this.phoneAndLess ? this.$refs.parent.getBoundingClientRect().left - 100 : this.$refs.parent.getBoundingClientRect().left;
        },
        onActivate(e) {
            if (!this.items.length) return;
            this.openSinglePopup({ id: this.id, e: e });
            this.updatePosition();
        },
        close() {
            this.closePopup(this.id);
        },
        radioGroupChangeHandler(e) {
            this.date = e;
        },
        applyDate() {
            if (this.isBtnDisable) return;
            this.$emit('changeDate', this.date);
            this.$emit('on-change-date', { date: this.date, popUpId: this.id });
        },
    },
    computed: {
        ...mapGetters('popupsController', popupsControllerGetters),
        ...mapGetters(['width']),
        desktopAndMore() {
            return this.width > 768;
        },
        tabletAndLess() {
            return this.width <= 768;
        },
        phoneAndLess() {
            return this.width <= 415;
        },
        compTop(){
            return this.tabletAndLess ? 20 : this.top;
        },
        dateList() {
            return this.items.map(v => ({
                key: moment(v).format("D MMMM YYYY"),
                value: v,
            }));
        },
        isBtnDisable() {
            return this.date === null;
        },
    },
    mounted() {
        window.addEventListener('scroll', this.updatePosition);
        this.updatePosition();
    },
    destroyed() {
        window.removeEventListener('scroll', this.updatePosition);
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.popup {
    position: fixed;
    z-index: 9999;
    top: 32px;
    left: 0;

    .card {
        background: #FFFFFF;
        box-shadow: 0 2px 12px rgba(107, 116, 123, 0.25);
        border-radius: 4px;
        padding: 32px;
        margin-bottom: 32px;
        max-width: 320px;
        min-width: 280px;
        position: relative;
        &._tablet {
          width: 100%;
          max-width: 100%;
        }

        .close {
            position: absolute;
            top: rem(10);
            right: rem(10);
            border-radius: 50%;
            background: white;
            box-shadow: 0 rem(6) rem(10) rgba(131, 134, 163, .12);
            width: rem(30);
            height: rem(30);
            font-size: rem(15);
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            color: grey;
            cursor: pointer;

            @include on-md {
                top: mdrem(5);
                right: mdrem(5);
                box-shadow: 0 rem(3) rem(5) rgba(131, 134, 163, 0.12);
                width: mdrem(25);
                height: mdrem(25);
                font-size: mdrem(15);
            }
            @include on-sm {
                top: smrem(5);
                right: smrem(5);
                box-shadow: 0 rem(3) rem(5) rgba(131, 134, 163, 0.12);
                width: smrem(25);
                height: smrem(25);
                font-size: smrem(15);
            }
            @include on-xs {
                top: xsrem(5);
                right: xsrem(5);
                box-shadow: 0 rem(3) rem(5) rgba(131, 134, 163, 0.12);
                width: xsrem(40);
                height: xsrem(40);
                font-size: xsrem(15);
            }
        }
    }

    &._phone {
        left: 0 !important;
        right: 0 !important;
    }
    &._tablet {
      left: 0 !important;
      right: 0 !important;
    }

    &.centered {
        top: 0;
        height: 100%;
        width: 100%;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(1, 1, 1, 0.07);
    }

    .title {
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 26px;
        text-align: center;
        color: #2A2626;
        margin-bottom: 24px;
        padding-left: 20px;
        padding-right: 20px;
    }

    .radio-group {
        max-height: 200px;
        overflow-y: scroll;
        @include custom-scroll-bar;
    }

    .calendar-btn {
        background: #4663AB;
        border-radius: 4px;
        width: 100%;
        color: white;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        height: 48px;
        cursor: pointer;
        font-weight: bold;
        font-size: 18px;
        line-height: 26px;

        &:hover {
            background-color: #356ED5;
        }

        &.disable {
            border: 2px solid #C3D5F6;
            color: #9FB7E3;
            background-color: #EFF3FB;
            cursor: not-allowed;
        }
    }
}
</style>
